module.exports = __webpack_public_path__ + "img/calendar@3x.2ef7dcf5.png";